module.exports = __webpack_public_path__ + "static/media/nerito_logo.243f2b93.svg";